/* eslint-disable max-classes-per-file */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGrid = document.getElementById('product-grid');
    this.paginationWrapper = document.querySelector('.js-pagination-wrapper');
    this.filterResultsCount = document.querySelector('.js-collection-filters-results-count');
    this.filterCount = document.querySelector('.js-collection-filters-count');
    const facetForm = this.querySelector('form');
    const that = this;

    this.debouncedOnSubmit = debounce((event) => {
      if ((
        event.target.id.includes('BrandSelect')
        || event.target.id.includes('ModelSelect')
        || event.target.id.includes('AutoYMMSelect')
        || event.target.id.includes('AutoTypeSizeSelect')
      )
        && SDG.Data.siteBranding === 'coverstore'
      ) return;

      if ((
        event.target.name.includes('filter_year')
        || event.target.name.includes('filter_make')
        || event.target.name.includes('filter_model')
        || event.target.name.includes('filter_submodel')
      )
        && SDG.Data.siteBranding === 'coverstore'
      ) {
        // Reset other selects
        const $selectsToReset = (() => {
          const selects = [];
          let next = event.target?.nextElementSibling;

          while (next) {
            const $matchingSelects = document.querySelectorAll(`select[id="${next.id}"]`)
            selects.push(...$matchingSelects);
            next = next.nextElementSibling;
          }

          return selects;
        })();

        $selectsToReset.forEach(($selectToReset) => {
          $selectToReset.value = '';
        });
      }

      if (event.target.id.includes('SizeDetails') && SDG.Data.siteBranding === 'coverstore') {
        this.onSizeInput(event);
        return;
      }

      this.onSubmitHandler(event);
    }, 800);

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Set all select elements to the same value
    if (SDG.Data.siteBranding === 'coverstore') {
      facetForm.addEventListener('input', (event) => {
        if (event.target.nodeName === 'SELECT' && SDG.Data.siteBranding === 'coverstore') {
          const $matchingSelectElements = document.querySelectorAll(`select[id="${event.target.id}"]`);
          $matchingSelectElements.forEach((selectElement) => {
            if (selectElement !== event.target) {
              selectElement.value = event.target.value;
            }
          });
        }
      });
    }

    facetForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (e.submitter?.dataset?.externalApiType) {
        that.fetchProductsFromExternalApi(e.submitter);
        return;
      }

      that.onSubmitHandler(e);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  connectedCallback() {
    FacetFiltersForm?.toggleClearAll();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    // resubmit the form when navigating back to the page with the back button
    const onBackClick = () => {
      const searchBySizeForm = document.querySelectorAll('.facets__auto-facets');
      if (!searchBySizeForm) return;
      // loop through desktop and mobile forms
      searchBySizeForm.forEach((form) => {
        if (form.checkVisibility()
          || form.parentElement?.previousElementSibling?.checkVisibility()) {
          // only submit if all inputs have a value
          const inputs = form.querySelectorAll('input');
          const emptyInput = [...inputs].some((input) => input.value === '');
          if (inputs.length && !emptyInput) {
            const searchButton = form.querySelector('button[type="submit"]');
            searchButton?.removeAttribute('disabled');
            searchButton?.click();
          }
        }
      });
    };
    window.addEventListener('pageshow', onBackClick);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, instance = null) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (instance) {
      const observer = new MutationObserver((_, observerInstance) => {
        const isPageRendered = !document.querySelector('.loading');
        if (isPageRendered) {
          observerInstance.disconnect(); // Stop observing
          instance.initSortOptions();
        }
      });

      observer.observe(document.getElementById('ProductGridContainer'), {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderPagination(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        FacetFiltersForm.toggleClearAll();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const { html } = FacetFiltersForm.filterData.find(filterDataUrl);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderPagination(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    FacetFiltersForm.toggleClearAll();
  }

  static renderProductGridContainer(html) {
    const productItem = SDG?.productItem();
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (productItem) {
      const $products = document.querySelectorAll('.js-product-item');

      if ($products?.length > 0) {
        [...$products].forEach(($product) => {
          productItem?.addProductItemEvent($product);

          if (SDG.Data.siteBranding === 'coverstore') {
            productItem?.addSwatchCarousel($product);
          }
        });
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const filterResultsCount = document.querySelector('.js-collection-filters-results-count');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (filterResultsCount) {
      filterResultsCount.innerHTML = `(${count.trim()})`;
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const filterCount = document.querySelector('.js-collection-filters-count');
    const newFilterCount = parsedHTML.querySelector('.js-facet-clear-count');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (filterCount && newFilterCount) {
      filterCount.innerHTML = `(${newFilterCount.innerHTML})`;
    }

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? '.mobile-facets__close-button'
          : '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const params = new URLSearchParams(searchParams);
    searchParams = params.toString();

    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event, true, this);
  }

  onSubmitHandler(event) {
    const buttonSubmit = event?.submitter?.tagName === 'BUTTON';
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      // Remove duplicates before submitting
      if (SDG.Data.siteBranding === 'coverstore') {
        const uniqueForms = forms.join('&').split('&').filter((item, index, arr) => arr.indexOf(item) === index);
        this.onSubmitForm(uniqueForms.join('&'), event);
      } else {
        this.onSubmitForm(forms.join('&'), event);
      }

      const hasFilters = forms.some((form) => form.includes('filter.'));
      const filterCount = forms.filter((form) => form.includes('filter.')).length;

      if (SDG.Data.siteBranding === 'coverstore' && hasFilters) {
        this.querySelector('details[id*="BrandModel-CollectionFilters"]')?.classList?.add('hide');
        this.querySelector('details[id*="SizeDetails-CollectionFilters"]')?.classList?.add('hide');
        document.querySelector('details[id*="BrandModelMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.add('hide');
        document.querySelector('details[id*="SizeMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.add('hide');
        document.querySelector('.js-facet-clear-alt-mobile')?.classList?.remove('hide');
        document.querySelector('.js-collection-filters-results-title')?.classList?.remove('hide');

        if (this.filterCount) {
          this.filterCount.innerText = `(${filterCount})`;
        }
      } else if (SDG.Data.siteBranding === 'coverstore' && !hasFilters) {
        this.querySelector('details[id*="BrandModel-CollectionFilters"]')?.classList?.remove('hide');
        this.querySelector('details[id*="SizeDetails-CollectionFilters"]')?.classList?.remove('hide');
        document.querySelector('details[id*="BrandModelMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.remove('hide');
        document.querySelector('details[id*="SizeMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.remove('hide');
        document.querySelector('.js-facet-clear-alt-mobile')?.classList?.add('hide');
        document.querySelector('.js-collection-filters-results-title')?.classList?.add('hide');
      }
    }

    if (buttonSubmit && SDG.Data.siteBranding === 'coverstore') {
      const $button = event.submitter;
      const isMobile = $button.parentNode.id.includes('Mobile');
      const $filtersDetails = this.querySelector('details.js-filter');
      if ($filtersDetails && isMobile) {
        $filtersDetails.removeAttribute('open');
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1
      ? ''
      : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, null, true, this);
  }

  static toggleClearAll() {
    const $clearAll = document.querySelector('.js-facet-clear');
    const $clearCount = document.querySelector('.js-facet-clear-count');
    const $inputs = document.querySelectorAll('.js-filter input') || [];
    const $facetsWrapperDesktop = document.getElementById('FacetsWrapperDesktop');
    const $carDetailsFiltersWrapper = $facetsWrapperDesktop?.querySelector('.js-car-details-filters');
    const $carDetailsFilters = $carDetailsFiltersWrapper?.querySelectorAll('.js-filter') || [];
    if ((
        (SDG.Data.siteBranding === 'coverstore' && $carDetailsFilters?.length > 0)
        || $inputs?.length > 0
      )
      && $clearAll
    ) {
      // Show hide clear All button
      if (
        (SDG.Data.siteBranding === 'coverstore' && [...$carDetailsFilters]?.some((input) => input.value !== ''))
        || [...$inputs].some((input) => input.checked)
      ) {
        $clearAll.classList.remove('hide');
      } else {
        $clearAll.classList.add('hide');
      }

      if ($clearCount) {
        const count = (
          [...$inputs].filter((input) => input.checked).length
          + [...$carDetailsFilters].filter((input) => input.value !== '').length
        )
        $clearCount.innerHTML = count;
      }
    }
  }

  initSortOptions() {
    const select = SDG?.select({
      callback: {
        onSelect: (event) => {
          // submit the form when a sort option is selected
          const target = event?.target || null;

          if (target?.value) {
            const val = target.value;
            const formElement = this.querySelector('form');
            const searchParams = new URLSearchParams(new FormData(formElement));
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('q') && !searchParams.has('q')) {
              searchParams.set('q', urlParams.get('q'));
            }
            // Set or update the `sort_by` parameter
            searchParams.set('sort_by', val);
            this.onSubmitForm(searchParams.toString(), null);
          }
        },
      },
    }) || null;

    if (select) {
      select.init();
    }
  }

  onSizeInput(event) {
    const $parent = event.target.parentElement;
    const $inputs = $parent.querySelectorAll('input');
    const $submitButton = $parent.querySelector('button[type="submit"]');

    if (!$parent || !$submitButton) return;

    const hasValue = [...$inputs].some((input) => input.value);

    if (!hasValue && !$submitButton.hasAttribute('disabled')) {
      $submitButton.setAttribute('disabled', true);
    } else if (hasValue && $submitButton.hasAttribute('disabled')) {
      $submitButton.removeAttribute('disabled');
    }
  }

  async fetchProductsFromExternalApi($submitButton) {
    const { externalApiType, bodyType, categoryUrl } = $submitButton.dataset || {};
    const { coverstoreBaseEndpoint } = SDG.Data || {};
    const $facetBrandSelect = this.querySelector('.js-facet-brand-select');
    const $facetModelSelect = this.querySelector('.js-facet-model-select');
    const $widthInput = this.querySelector('.js-facet-size-width');
    const $heightInput = this.querySelector('.js-facet-size-height');
    const $depthInput = this.querySelector('.js-facet-size-depth');
    const $sizeDetails = this.querySelector('details[id*="SizeDetails-CollectionFilters"]');
    const $brandModelDetails = this.querySelector('details[id*="BrandModel-CollectionFilters"]');
    const $sizeDetailsMobile = document.querySelector('details[id*="SizeMobile-CollectionFilters"]')?.closest('facet-filters-form');
    const $brandModelDetailsMobile = document.querySelector('details[id*="BrandModelMobile-CollectionFilters"]')?.closest('facet-filters-form');
    const make = $facetBrandSelect ? $facetBrandSelect.value : '';
    const model = $facetModelSelect ? $facetModelSelect.value : '';
    const productItem = SDG?.productItem();
    let apiUrl;
    let body;
    if (externalApiType === 'Grill') {
      apiUrl = `${coverstoreBaseEndpoint}/applicationdata/grill/item`;
      body = JSON.stringify({
        body_type: bodyType,
        make,
        model,
      });
    } else if (externalApiType === 'AC') {
      apiUrl = `${coverstoreBaseEndpoint}/applicationdata/ac/item`;
      body = JSON.stringify({
        body_type: bodyType,
        make,
        model,
      });
    } else if (externalApiType === 'Size') {
      apiUrl = `${coverstoreBaseEndpoint}/applicationdata/search-by-size`;
      body = JSON.stringify({
        category_url: categoryUrl,
        w: $widthInput?.value,
        h: $heightInput?.value,
        d: $depthInput?.value,
      });
    }

    if (!body) return;

    const productsData = await fetch(apiUrl, {
      method: 'POST',
      body,
    })
      .then((res) => res.json())
      .then((data) => {
        const $productGrid = document.getElementById('product-grid');

        if ($productGrid) {
          $productGrid.innerHTML = '';

          if (data.length === 0) {
            const $noResults = document.createElement('div');
            $noResults.className = 'no-results';
            
            // Only use the custom error message for coverstore branding
            if (SDG && SDG.Data && SDG.Data.siteBranding === 'coverstore') {
              // Find the search-sizes-error-product-info element and clone it
              const $searchSizesError = document.querySelector('.facets__search-sizes-error .search-sizes-error-info');
              if ($searchSizesError) {
                // Clone the element to avoid removing it from its original location
                const $searchSizesErrorClone = $searchSizesError.cloneNode(true);
                $noResults.appendChild($searchSizesErrorClone);
              } else {
                // Fallback if element not found
                $noResults.innerHTML = '<p>No products found for the selected criteria.</p>';
              }
            } else {
              // Default message for other brands
              $noResults.innerHTML = '<p>No products found for the selected criteria.</p>';
            }

            $productGrid.appendChild($noResults);

            const paginationWrapper = document.querySelector('.pagination-wrapper');
            if (paginationWrapper) paginationWrapper.remove();
            return [];
          }

          data.forEach((product) => {
            const $productItem = this.productItemHtml(product);
            $productGrid.appendChild($productItem);
            productItem?.addProductItemEvent($productItem);

            if (SDG.Data.siteBranding === 'coverstore') {
              productItem?.addSwatchCarousel($productItem);
            }
          });

          this.updatePaginationForExternalResults();
        }

        return data;
      })
      .catch((err) => {
        console.error(err);
      });

    const storefrontQuery = `
      query getProductsByIds($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            handle
            title
            metafields(identifiers: [
              {namespace: "dci", key: "plp-stitching"},
              {namespace: "okendo", key: "summaryData"}
            ]) {
              key
              value
              references(first: 10) {
                nodes {
                  ... on Metaobject {
                    id
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    const variables = {
      ids: productsData.map((product) => `gid://shopify/Product/${product.product_id}`),
    };

    this.querySelector('.js-search-and-discovery-filters')?.classList?.add('hide');
    document.querySelector('.js-filter-drawer-toggle')?.classList?.add('hide');
    [...document.querySelectorAll('.js-facet-clear-alt')]
      .forEach((element) => element.classList.remove('hide'));
    document.querySelector('.js-facet-clear-alt-mobile')?.classList?.remove('hide');
    $submitButton?.closest('.js-filter.mobile-only')?.removeAttribute('open');

    if (externalApiType === 'Grill' || externalApiType === 'AC') {
      $sizeDetails?.classList?.add('hide');
      $sizeDetailsMobile?.classList?.add('hide');
    } else if (externalApiType === 'Size') {
      $brandModelDetails?.classList?.add('hide');
      $brandModelDetailsMobile?.classList?.add('hide');
    }

    if (this.paginationWrapper) {
      this.paginationWrapper.classList.add('hide');
    }

    this.fetchStorefrontApi(storefrontQuery, variables)
      .then((storefrontProductData) => {
        storefrontProductData.nodes.forEach((storefrontProduct) => {
          if (!storefrontProduct?.metafields && !storefrontProduct.metafields.length) return;
          const $productGrid = document.getElementById('product-grid');
          const $productItem = $productGrid.querySelector(`.product-item[data-product="${storefrontProduct.handle}"]`);
          const $badges = $productItem.querySelector('.js-product-item-badges-over-image');
          const $reviews = $productItem.querySelector('.js-product-item-badges');
          const $swatches = [...$productItem.querySelectorAll('.js-product-item-swatch')];
          const badges = productsData.find((mf) => mf.handle === storefrontProduct.handle)?.badge;//use badge 1, badge 2 from application data instead of PLP Badge
          const okendoData = storefrontProduct.metafields.find((mf) => mf?.key === 'summaryData');

          // Swatches
          if (SDG.Data.siteBranding === 'coverstore' && $swatches) {
            const plpStitching = JSON.parse(storefrontProduct.metafields.find((mf) => mf?.key === 'plp-stitching')?.value);
            const swatches = plpStitching?.length ? plpStitching[0]?.Swatches : [];

            $swatches.forEach(($swatch, index) => {
              const $swatchImg = $swatch.querySelector('img');
              if ($swatchImg && swatches[index]) {
                $swatchImg.src = swatches[index].image;
              }
            });
          }

          if (badges && $badges) {
            let count = 0;
            badges.forEach((badge) => {
              if(badge !== '') {
                if(count === 0) {
                  $badges.innerHTML += `
                    <div class="product-item__badge-over-image"
                      style="background-color: #11A769; color: #fff; border: 1px solid #11A769;"
                    >
                      ${badge}
                    </div>
                  `;
                }
                else if(count === 1) {
                  $badges.innerHTML += `
                    <div class="product-item__badge-over-image"
                      style="color: #636365; border: 1px solid #636365;"
                    >
                      ${badge}
                    </div>
                  `;
                }
              }
              count++;
            });
          }

          if (okendoData && okendoData.value && $reviews) {
            const okendoFields = JSON.parse(okendoData.value);
            const rating = okendoFields?.reviewAverageValue || 0;

            if (rating) {
              $reviews.innerHTML += `
              <li class="product-item__badge">
                <p class="product-item__badge-text">
                  <i class="icon icon--review-star-gold"></i>
                  ${rating}
                </p>
              </li>
              `;
            }
          }
        });

        if (this.filterResultsCount) {
          const count = productsData.length;
          this.filterResultsCount.innerHTML = `(${count})`;
          document.querySelector('.js-collection-filters-results-title')?.classList?.remove('hide');
        } else {
          document.querySelector('.js-collection-filters-results-title')?.classList?.add('hide');
        }

        if (this.filterCount) {
          this.filterCount.innerHTML = '(1)';
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updatePaginationForExternalResults() {
    // For external API calls, we always remove pagination since we show all results at once
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    if (paginationWrapper) paginationWrapper.remove();
  }

  productItemHtml(product) {
    const percentOff = product.starting_price && product.actual_price
      ? Math.round(((product.starting_price - product.actual_price) / product.starting_price) * 100)
      : 0;
    const { swatches } = product;
    const customSwatchUrl = swatches?.length ? swatches[0].handle : false;
    const isB2b = SDG?.Data?.customer?.isB2b;
    const isCoverstore = SDG?.Data?.siteBranding === 'coverstore';

    const html = `
      <div class="grid__item js-product-parent scroll-trigger animate--slide-in" data-cascade style="--animation-order: 1;">
        <article class="product-item js-product-item" data-product="${product.handle}" data-initialized="true">
          <div class="product-item__inner js-product-item-content">
            <div class="js-product-item-details" data-product="${product.handle}">
              <div class="product-item__media">
                <div class="product-item__badges-over-image js-product-item-badges-over-image">
                  ${product.actual_price && !(isCoverstore && isB2b)
    ? '<div class="product-item__badge-over-image">Sale</div>'
    : ''
}
                </div>
                <div class="product-item__gallery">
                  <a
                    href="/products/${customSwatchUrl ? customSwatchUrl : product.handle}"
                    class="product-item__gallery-link"
                  >
                    <div class="product-item__media-wrapper" style="padding-bottom: 75%;">
                      <img class="product-item__image lazyload" data-src="${product.img_default}">
                    </div>
                  </a>
                </div>
              </div>
              <div class="product-item__details">
                <ul class="product-item__badges list-reset js-product-item-badges"></ul>
                <div class="product-item__title">
                  <a
                    href="/products/${customSwatchUrl ? customSwatchUrl : product.handle}"
                  >
                    <h3 class="product-item__title-text">
                      ${product.product_title}
                    </h3>
                  </a>
                </div>
                <div class="product-item__price">
                  Starts at
                  ${product.actual_price && !(isCoverstore && isB2b)
    ? `<span class="product-item__price--original product-item__price--strikethrough">$${product.starting_price}</span><span class="product-item__price--sale">&nbsp;$${product.actual_price} (${percentOff}% Off)</span>`
    : `<span class="product-item__price--original">$${product.starting_price}</span>`}
                </div>
                <div class="product-item__sizes-available">
                  ${product.sizes_available}
                </div>
              </div>
            </div>
          </div>
          <ul class="product-item__swatches list-reset js-product-item-swatches hide">
            ${product.swatches.map((swatch) => `
                <li>
                  <button
                    type="button"
                    class="product-item__swatch btn-icon js-product-item-swatch"
                    data-url="${swatch.handle}"
                    data-product="${swatch.handle.split('?')?.[0]}"
                  >
                    <img src="${swatch.img}" alt="${product.product_title} swatch">
                  </button>
                </li>
            `).join('')}
          </ul>
        </article>
      </div>
    `;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.firstChild;
  }

  async fetchStorefrontApi(query, variables = {}) {
    const storefrontKey = SDG?.Data.storeToken || null;
    const endpoint = `https://${Shopify.shop}/api/2025-04/graphql.json`;

    if (!storefrontKey) {
      throw new Error('Storefront API key is not set');
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontKey,
      },
      body: JSON.stringify({ query, variables }),
    });

    const { data, errors } = await response.json();

    if (errors) {
      throw new Error(errors[0].message);
    }

    return data;
  }

  static renderPagination(html) {
    const paginationElement = new DOMParser().parseFromString(html, 'text/html').querySelector('.pagination-wrapper');
    const container = document.querySelector('.pagination-wrapper');
    const collectionGrid = document.querySelector('.collection-grid');

    if (paginationElement && container) {
      container.innerHTML = paginationElement.innerHTML;
    } else if (paginationElement && !container) {
      // If pagination doesn't exist but should be added
      const productGridContainer = document.getElementById('ProductGridContainer');
      if (productGridContainer) {
        collectionGrid.insertAdjacentHTML('afterend', paginationElement.outerHTML);
      }
    } else if (!paginationElement && container) {
      // If pagination existed but should be removed
      container.remove();
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetBrandModelSelect extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.facetBrandSelect = this.form.querySelector('.js-facet-brand-select');
    this.facetModelSelect = this.form.querySelector('.js-facet-model-select');

    if (this.facetBrandSelect) {
      this.populateBrandSelect();
      this.addFacetBrandSelectListener();
      this.addFacetModelSelectListener();
    }
  }

  populateBrandSelect() {
    const { bodyType, type } = this.facetBrandSelect.dataset || {};
    let apiUrl;

    if (!bodyType || !type) return;

    if (type === 'Grill') {
      apiUrl = 'https://api.coverstore.com/applicationdata/grill/make';
    } else if (type === 'AC') {
      apiUrl = 'https://api.coverstore.com/applicationdata/ac/make';
    }

    fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify({
        body_type: bodyType,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const brands = data;

        brands.forEach((brand) => {
          const option = document.createElement('option');
          option.value = brand;
          option.textContent = brand;
          this.facetBrandSelect.appendChild(option);
        });
        /**
         * If the brand <select> has a data-sbb attribute, it means we are on a "Shop by Brand" collection page.
         * The value of data-sbb is the current brand (collection title).
         * When present, the brand select will be auto-selected and hidden, and only the model select will be shown.
         * This attribute is set in the Liquid template for collections with the "Shop Grill Covers by Brand" breadcrumb.
         */
        if(this.facetBrandSelect.dataset?.sbb) {
          this.facetBrandSelect.value = this.facetBrandSelect.dataset?.sbb;
          this.facetBrandSelect.dispatchEvent(new Event('change'));
        }
      });
  }

  addFacetBrandSelectListener() {
    if (this.facetModelSelect) {
      this.facetBrandSelect.addEventListener('change', (event) => {
        this.populateModelSelect(event);
        this.facetModelSelect.disabled = false;
      });
    }
  }

  addFacetModelSelectListener() {
    this.facetModelSelect.addEventListener('change', (e) => {
      const $parent = e.target.parentElement;
      const $submitButton = $parent.querySelector('button[type="submit"]');

      if (!$parent || !$submitButton) return;

      const hasValue = e.target.value !== '';

      if (!hasValue && !$submitButton.hasAttribute('disabled')) {
        $submitButton.setAttribute('disabled', true);
      } else if (hasValue && $submitButton.hasAttribute('disabled')) {
        $submitButton.removeAttribute('disabled');
      }
    });
  }

  populateModelSelect(event) {
    const brand = event.target.value;
    const { bodyType, type } = this.facetBrandSelect.dataset || {};
    const $parent = event.target.parentElement;
    const $submitButton = $parent.querySelector('button[type="submit"]');
    let apiUrl;

    if ($submitButton) {
      $submitButton.setAttribute('disabled', true);
    }

    if (type === 'Grill') {
      apiUrl = 'https://api.coverstore.com/applicationdata/grill/model';
    } else if (type === 'AC') {
      apiUrl = 'https://api.coverstore.com/applicationdata/ac/model';
    }

    fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify({
        body_type: bodyType,
        make: brand,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const models = data;

        // Clear existing options
        const defaultOption = this.facetModelSelect.firstElementChild;
        this.facetModelSelect.innerHTML = '';
        this.facetModelSelect.appendChild(defaultOption);
        defaultOption.selected = true;

        models.forEach((model) => {
          const option = document.createElement('option');
          option.value = model;
          option.textContent = model;
          this.facetModelSelect.appendChild(option);
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

customElements.define('facet-brand-model-select', FacetBrandModelSelect);

async function fetchStorefrontApi(query, variables = {}) {
  const storefrontKey = SDG?.Data.storeToken || null;
  const endpoint = `https://${Shopify.shop}/api/2025-04/graphql.json`;

  if (!storefrontKey) {
    throw new Error('Storefront API key is not set');
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontKey,
    },
    body: JSON.stringify({ query, variables }),
  });

  const { data, errors } = await response.json();

  if (errors) {
    throw new Error(errors[0].message);
  }

  return data;
}
class FacetYMMSelect extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.facetYearSelect = this.form.querySelector('.js-facet-year-select');
    this.facetMakeSelect = this.form.querySelector('.js-facet-make-select');
    this.facetModelSelect = this.form.querySelector('.js-facet-model-select');
    this.facetSubmodelSelect = this.form.querySelector('.js-facet-submodel-select');
    this.button = this.form.querySelector('button[type="button"]');

    this.loadFromSession = false;
    const sessionVehicleSelection = sessionStorage.getItem('new_vehicle_selected_options');
    if (sessionVehicleSelection) {
      this.loadFromSession = true;
      this.setYMMFromSession(sessionVehicleSelection);
    }

    if (this.facetYearSelect) {
      if (!this.loadFromSession) {
        this.populateYMMSelect('year');
      }
      this.facetYearSelect.addEventListener('change', () => {
        this.populateYMMSelect('make');
        this.resetSelectedOption('make');
        this.resetSelectedOption('model');
        this.resetSelectedOption('submodel');
        this.saveYMMToSession();
      });
    }
    if (this.facetMakeSelect) {
      this.facetMakeSelect.addEventListener('change', () => {
        this.populateYMMSelect('model');
        this.resetSelectedOption('model');
        this.resetSelectedOption('submodel');
        this.saveYMMToSession();
      });
    }
    if (this.facetModelSelect) {
      this.facetModelSelect.addEventListener('change', () => {
        this.populateYMMSelect('submodel');
        this.resetSelectedOption('submodel');
        this.saveYMMToSession();
      });
    }
    if (this.facetSubmodelSelect) {
      this.facetSubmodelSelect.addEventListener('change', (event) => {
        this.populateYMMSelect('style');
        this.saveYMMToSession();
        const $parent = event.target.parentElement;
        const $submitButton = $parent.querySelector('button[type="button"]');

        if (!$parent || !$submitButton) return;

        const hasValue = event.target.value !== '';

        if (!hasValue && !$submitButton.hasAttribute('disabled')) {
          $submitButton.setAttribute('disabled', true);
        } else if (hasValue && $submitButton.hasAttribute('disabled')) {
          $submitButton.removeAttribute('disabled');
        }
      });
    }
    if (this.button) {
      this.button.addEventListener('click', () => {
        if (SDG.Data.siteBranding === 'coverstore') {
          const isMobile = this.button.parentNode.id.includes('Mobile');
          const $filtersDetails = this.closest('details.js-filter');
          if ($filtersDetails && isMobile) {
            $filtersDetails.removeAttribute('open');
          }
        }
      });
    }
  }

  async populateYMMSelect(type, YMMFromSession = null) {
    if (!type) return;
    const baseUrl = 'https://api.coverstore.com/vehicle-lookup/vehicle';

    try {
      if (type === 'year') {
        const res = await fetch(`${baseUrl}/year`);
        const data = await res.json();
        if (!data || !data.body) throw new Error('No data found');

        const yearData = data.body;
        this.facetYearSelect.innerHTML = '<option value="" disabled selected>Year</option>';
        yearData.forEach((year) => {
          const option = document.createElement('option');
          option.value = year;
          option.textContent = year;
          this.facetYearSelect.appendChild(option);
        });
        if (YMMFromSession && YMMFromSession.year) {
          this.facetYearSelect.value = YMMFromSession.year;
        }
      } else if (type === 'make') {
        const yearSelected = this.facetYearSelect.value;
        const res = await fetch(`${baseUrl}/year/${yearSelected}/make`);
        const data = await res.json();
        if (!data || !data.body) throw new Error('No data found');

        const makeData = data.body;

        this.facetMakeSelect.innerHTML = '<option value="" disabled selected>Make</option>';
        makeData.forEach((make) => {
          const option = document.createElement('option');
          option.value = make;
          option.textContent = make;
          this.facetMakeSelect.appendChild(option);
        });
        this.facetMakeSelect.disabled = false;
        this.facetModelSelect.innerHTML = '<option value="" disabled selected>Model</option>';
        this.facetSubmodelSelect.innerHTML = '<option value="" disabled selected>Submodel</option>';
        if (YMMFromSession && YMMFromSession.make) {
          this.facetMakeSelect.value = YMMFromSession.make;
        }
      } else if (type === 'model') {
        const yearSelected = this.facetYearSelect.value;
        const makeSelected = this.facetMakeSelect.value;
        const res = await fetch(`${baseUrl}/year/${yearSelected}/make/${makeSelected}/model`);
        const data = await res.json();
        if (!data || !data.body) throw new Error('No data found');

        const modelData = data.body;

        this.facetModelSelect.innerHTML = '<option value="" disabled selected>Model</option>';
        modelData.forEach((model) => {
          const option = document.createElement('option');
          option.value = model;
          option.textContent = model;
          this.facetModelSelect.appendChild(option);
        });
        this.facetModelSelect.disabled = false;
        this.facetSubmodelSelect.innerHTML = '<option value="" disabled selected>Submodel</option>';
        if (YMMFromSession && YMMFromSession.model) {
          this.facetModelSelect.value = YMMFromSession.model;
        }
      } else if (type === 'submodel') {
        const yearSelected = this.facetYearSelect.value;
        const makeSelected = this.facetMakeSelect.value;
        const modelSelected = this.facetModelSelect.value;
        const res = await fetch(`${baseUrl}/year/${yearSelected}/make/${makeSelected}/model/${modelSelected}/submodel`);
        const data = await res.json();
        if (!data || !data.body) throw new Error('No data found');

        const submodelData = data.body;

        this.facetSubmodelSelect.innerHTML = '<option value="" disabled selected>Submodel</option>';
        submodelData.forEach((submodel) => {
          const option = document.createElement('option');
          option.value = submodel;
          option.textContent = submodel;
          this.facetSubmodelSelect.appendChild(option);
        });
        this.facetSubmodelSelect.disabled = false;
        if (YMMFromSession && YMMFromSession.submodel) {
          this.facetSubmodelSelect.value = YMMFromSession.submodel;
        }
      } else if (type === 'style') {
        const yearSelected = this.facetYearSelect.value;
        const makeSelected = this.facetMakeSelect.value;
        const modelSelected = this.facetModelSelect.value;
        const submodelSelected = this.facetSubmodelSelect.value;

        const res = await fetch(`${baseUrl}/type/pdp/year/${yearSelected}/make/${makeSelected}/model/${modelSelected}/submodel/${submodelSelected}`);
        const data = await res.json();
        if (!data || !data.body) throw new Error('No data found');

        const handleData = data.body;

        document.querySelectorAll('li.grid__item').forEach((product) => product.classList.remove('hide'));
        document.querySelectorAll('.product-item__swatches li').forEach((swatch) => swatch.classList.add('hide'));
        await Promise.all(handleData.map(async (handle) => {
          const storefrontQuery = `
            query {
              product(handle: "${handle}") {
                id
                handle
                title
                featuredImage {
                  url
                }
                priceRange {
                  minVariantPrice {
                    amount
                  }
                }
                compareAtPriceRange {
                  minVariantPrice {
                    amount
                  }
                }
                metafields(identifiers: [
                  {namespace: "dci", key: "color-name"},
                  {namespace: "dci", key: "collection-name"}
                ]) {
                  key
                  value
                  references(first: 10) {
                    nodes {
                      ... on Metaobject {
                        id
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          `;
          try {
            const storefrontProductData = await fetchStorefrontApi(storefrontQuery);
            const storefrontProduct = storefrontProductData.product;
            if (!storefrontProduct && !storefrontProduct?.metafields.length) return;
            const collectionName = storefrontProduct.metafields.find((mf) => mf?.key === 'collection-name')?.value || '';
            const colorName = storefrontProduct.metafields.find((mf) => mf?.key === 'color-name')?.value || '';
            const minPrice = storefrontProduct.priceRange?.minVariantPrice?.amount || '';
            const minCompareAtPrice = storefrontProduct.compareAtPriceRange?.minVariantPrice?.amount || '';
            const $productGrid = document.getElementById('product-grid');
            const $productItem = $productGrid.querySelector(`.product-item[data-product*="${collectionName.replace(/\s/g, '-').toLowerCase()}"]`);
            const $swatches = [...$productItem.querySelectorAll('.js-product-item-swatch')];

            if ($productItem) {
              $productItem.dataset.product = handle;
              const collectionColor = `${collectionName} ${colorName}`.replace(/\s/g, '-').toLowerCase();
              const pdpLink = `/products/${handle}?year=${yearSelected}&make=${makeSelected}&model=${modelSelected}&submodel=${submodelSelected}`;
              $productItem.querySelectorAll(`.js-product-item-details[data-product*="${collectionColor}"]`).forEach((element) => {
                element.dataset.product = handle;
                // update image, link
                element.querySelectorAll('.product-item__gallery a').forEach((e) => {
                  e.href = pdpLink;
                  e.querySelector('img').dataset.srcset = storefrontProduct.featuredImage.url;
                  e.querySelector('img').dataset.src = storefrontProduct.featuredImage.url;
                });
                // update title
                element.querySelectorAll('.product-item__details .product-item__title').forEach((e) => {
                  e.innerHTML = `<a href="${pdpLink}">
                    <h3 class="product-item__title-text">${yearSelected} ${makeSelected} ${modelSelected} Car Cover ${collectionName}</h3>
                  </a>`;
                });
                // update price
                element.querySelectorAll('.product-item__price').forEach((e) => {
                  if (minCompareAtPrice > 0 && minCompareAtPrice !== minPrice) {
                    const percentOff = Math.round(
                      ((minCompareAtPrice - minPrice) / minCompareAtPrice) * 100,
                    );
                    e.innerHTML = `<span class="product-item__price--original product-item__price--strikethrough">$${minCompareAtPrice}</span><span class="product-item__price--sale">&nbsp;$${minPrice} (${percentOff}% off)</span>`;
                  } else {
                    e.innerHTML = `<span class="product-item__price--original">$${minPrice}</span>`;
                  }
                });
              });
            }

            // Swatches
            if (SDG.Data.siteBranding === 'coverstore' && $swatches) {
              $swatches.forEach(($swatch) => {
                const $swatchName = $swatch.querySelector('.screenreader');
                if ($swatchName && $swatchName.textContent.trim() === `${collectionName} ${colorName}`) {
                  $swatch.dataset.product = handle;
                  $swatch.parentElement.classList.remove('hide');
                }
              });
            }
          } catch (err) {
            console.error(err);
          }
        }));
        // hide product if no swatches are available
        document.querySelectorAll('li.grid__item').forEach((product) => {
          if (product.querySelectorAll('.js-product-item-swatches li:not(.hide)').length === 0) {
            product.classList.add('hide');
          }
        });
      }
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error);
    }
  }

  resetSelectedOption(type) {
    if (type === 'make') {
      this.facetMakeSelect.selectedIndex = 0;
    } else if (type === 'model') {
      this.facetModelSelect.selectedIndex = 0;
    } else if (type === 'submodel') {
      this.facetSubmodelSelect.selectedIndex = 0;
    }
  }

  saveYMMToSession() {
    const vehicleInfo = {
      year: this.facetYearSelect.value,
      make: this.facetMakeSelect.value === 'Make' ? '' : this.facetMakeSelect.value,
      model: this.facetModelSelect.value === 'Model' ? '' : this.facetModelSelect.value,
      submodel: this.facetSubmodelSelect.value === 'Submodel' ? '' : this.facetSubmodelSelect.value,
    };
    sessionStorage.setItem('new_vehicle_selected_options', JSON.stringify(vehicleInfo));
  }

  async setYMMFromSession(sessionVehicleSelection) {
    try {
      const initialSelections = JSON.parse(sessionVehicleSelection);
      await this.populateYMMSelect('year', initialSelections);
      if (initialSelections.year) {
        await this.populateYMMSelect('make', initialSelections);
      }
      if (initialSelections.make) {
        await this.populateYMMSelect('model', initialSelections);
      }
      if (initialSelections.model) {
        await this.populateYMMSelect('submodel', initialSelections);
      }
      if (initialSelections.submodel) {
        await this.populateYMMSelect('style', initialSelections);
        this.button.removeAttribute('disabled');
      }
    } catch (e) {
      console.error('Failed to parse sessionStorage data:', e);
    } finally {
      this.loadFromSession = false;
    }
  }
}

customElements.define('facet-ymm-select', FacetYMMSelect);

class FacetTypeSizeSelect extends HTMLElement {
  constructor() {
    super();
    this.facetTypeSelect = this.querySelector('.js-facet-vtype-select');
    this.facetSizeSelect = this.querySelector('.js-facet-vsize-select');
    this.button = this.querySelector('button');
    this.baseUrl = 'https://api.coverstore.com/vehicle-lookup/vehicle';
    this.resultHandles = [];

    if (this.facetTypeSelect) {
      this.populateTypeSelect();
      this.facetTypeSelect.addEventListener('change', () => {
        const defaultOption = this.facetSizeSelect.firstElementChild;
        this.facetSizeSelect.innerHTML = '';
        this.facetSizeSelect.appendChild(defaultOption);
        defaultOption.selected = true;
        this.facetSizeSelect.disabled = true;
        if (this.button) this.button.setAttribute('disabled', true);
        this.resultHandles = [];
        this.populateSizeSelect();
      });
    }

    if (this.facetSizeSelect) {
      this.facetSizeSelect.addEventListener('change', (event) => {
        this.fetchResult();
        const $parent = event.target.parentElement;
        const $submitButton = $parent.querySelector('button[type="button"]');

        if (!$parent || !$submitButton) return;

        const hasValue = event.target.value !== '';

        if (!hasValue && !$submitButton.hasAttribute('disabled')) {
          $submitButton.setAttribute('disabled', true);
        } else if (hasValue && $submitButton.hasAttribute('disabled')) {
          $submitButton.removeAttribute('disabled');
        }
      });
    }

    if (this.button) {
      this.button.addEventListener('click', () => {
        if (SDG.Data.siteBranding === 'coverstore') {
          const isMobile = this.button.parentNode.id.includes('Mobile');
          const $filtersDetails = this.closest('details.js-filter');
          if ($filtersDetails && isMobile) {
            $filtersDetails.removeAttribute('open');
          }
        }
      });
    }
  }

  async populateTypeSelect() {
    try {
      const res = await fetch(`${this.baseUrl}/vtype`);
      const data = await res.json();
      if (!data || !data.body) throw new Error('No data found');

      data.body.forEach((type) => {
        const option = document.createElement('option');
        option.value = type;
        option.textContent = type;
        this.facetTypeSelect.appendChild(option);
      });
    } catch (err) {
      console.error('Error fetching vtype data:', err);
    }
  }

  async populateSizeSelect() {
    const type = this.facetTypeSelect.value;
    if (!type) return;

    try {
      const res = await fetch(`${this.baseUrl}/vtype/${encodeURIComponent(type)}/vsize`);
      const data = await res.json();
      if (!data || !data.body) throw new Error('No data found');

      data.body.forEach((size) => {
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size;
        this.facetSizeSelect.appendChild(option);
      });
      this.facetSizeSelect.disabled = false;
    } catch (err) {
      console.error('Error fetching vsize data:', err);
    }
  }

  async fetchResult() {
    const type = this.facetTypeSelect.value;
    const size = this.facetSizeSelect.value;
    if (!type || !size) return;

    try {
      const res = await fetch(`${this.baseUrl}/vtype/${encodeURIComponent(type)}/vsize/${encodeURIComponent(size)}`);
      const data = await res.json();
      if (!data || !data.body) throw new Error('No data found');

      this.resultHandles = data.body;
      const handleData = data.body;

      document.querySelectorAll('li.grid__item').forEach((product) => product.classList.remove('hide'));
      document.querySelectorAll('.product-item__swatches li').forEach((swatch) => swatch.classList.add('hide'));
      await Promise.all(handleData.map(async (handle) => {
        const storefrontQuery = `
          query {
            product(handle: "${handle}") {
              id
              handle
              title
              featuredImage {
                url
              }
              priceRange {
                minVariantPrice {
                  amount
                }
              }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                }
              }
              metafields(identifiers: [
                {namespace: "dci", key: "color-name"},
                {namespace: "dci", key: "collection-name"}
              ]) {
                key
                value
                references(first: 10) {
                  nodes {
                    ... on Metaobject {
                      id
                      fields {
                        key
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        `;
        try {
          const storefrontProductData = await fetchStorefrontApi(storefrontQuery);
          const storefrontProduct = storefrontProductData.product;
          if (!storefrontProduct && !storefrontProduct?.metafields.length) return;
          const collectionName = storefrontProduct.metafields.find((mf) => mf?.key === 'collection-name')?.value || '';
          const colorName = storefrontProduct.metafields.find((mf) => mf?.key === 'color-name')?.value || '';
          const minPrice = storefrontProduct.priceRange?.minVariantPrice?.amount || '';
          const minCompareAtPrice = storefrontProduct.compareAtPriceRange?.minVariantPrice?.amount || '';
          const $productGrid = document.getElementById('product-grid');
          const $productItem = $productGrid.querySelector(`.product-item[data-product*="${collectionName.replace(/\s/g, '-').toLowerCase()}"]`);
          const $swatches = [...$productItem.querySelectorAll('.js-product-item-swatch')];

          if ($productItem) {
            $productItem.dataset.product = handle;
            const collectionColor = `${collectionName} ${colorName}`.replace(/\s/g, '-').toLowerCase();
            const pdpLink = `/products/${handle}?vtype=${encodeURIComponent(type)}&vsize=${encodeURIComponent(size)}`;
            $productItem.querySelectorAll(`.js-product-item-details[data-product*="${collectionColor}"]`).forEach((element) => {
              element.dataset.product = handle;
              // update image, link
              element.querySelectorAll('.product-item__gallery a').forEach((e) => {
                e.href = pdpLink;
                e.querySelector('img').dataset.srcset = storefrontProduct.featuredImage.url;
                e.querySelector('img').dataset.src = storefrontProduct.featuredImage.url;
              });
              // update title
              element.querySelectorAll('.product-item__details .product-item__title').forEach((e) => {
                e.innerHTML = `<a href="${pdpLink}">
                  <h3 class="product-item__title-text">${storefrontProduct.title}</h3>
                </a>`;
              });
              // update price
              element.querySelectorAll('.product-item__price').forEach((e) => {
                if (minCompareAtPrice > 0 && minCompareAtPrice !== minPrice) {
                  const percentOff = Math.round(
                    ((minCompareAtPrice - minPrice) / minCompareAtPrice) * 100,
                  );
                  e.innerHTML = `<span class="product-item__price--original product-item__price--strikethrough">$${minCompareAtPrice}</span><span class="product-item__price--sale">&nbsp;$${minPrice} (${percentOff}% off)</span>`;
                } else {
                  e.innerHTML = `<span class="product-item__price--original">$${minPrice}</span>`;
                }
              });
            });
          }

          // Swatches
          if (SDG.Data.siteBranding === 'coverstore' && $swatches) {
            $swatches.forEach(($swatch) => {
              const $swatchName = $swatch.querySelector('.screenreader');
              if ($swatchName && $swatchName.textContent.trim() === `${collectionName} ${colorName}`) {
                $swatch.dataset.product = handle;
                $swatch.parentElement.classList.remove('hide');
              }
            });
          }
        } catch (err) {
          console.error(err);
        }
      }));
      // hide product if no swatches are available
      document.querySelectorAll('li.grid__item').forEach((product) => {
        if (product.querySelectorAll('.js-product-item-swatches li:not(.hide)').length === 0) {
          product.classList.add('hide');
        }
      });
    } catch (err) {
      console.error('Error fetching type/size result:', err);
    }
  }
}

customElements.define('facet-type-size-select', FacetTypeSizeSelect);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.facetLink = this.querySelector('a');
    this.facetLink.setAttribute('role', 'button');
    this.facetLink.addEventListener('click', this.closeFilter.bind(this));
    this.facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    this.paginationWrapper = document.querySelector('.js-pagination-wrapper');
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    const hasFilters = this.facetLink.href.includes('filter.');

    if (SDG.Data.siteBranding === 'coverstore' && !hasFilters) {
      [...document.querySelectorAll('.js-facet-input')]
        .forEach((element) => element.checked = false);
      [...document.querySelectorAll('.js-facet-clear-alt')]
        .forEach((element) => element.classList.add('hide'));
      document.querySelector('.js-facet-clear-alt-mobile')?.classList?.add('hide');
      document.querySelector('.js-collection-filters-results-title')?.classList?.add('hide');
      form.querySelector('.js-search-and-discovery-filters')?.classList?.remove('hide');
      form.querySelector('details[id*="BrandModel-CollectionFilters"]')?.classList?.remove('hide');
      form.querySelector('details[id*="SizeDetails-CollectionFilters"]')?.classList?.remove('hide');
      document.querySelector('details[id*="SizeMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.remove('hide');
      document.querySelector('details[id*="BrandModelMobile-CollectionFilters"]')?.closest('facet-filters-form')?.classList?.remove('hide');
      document.querySelector('.js-filter-drawer-toggle')?.classList?.remove('hide');

      if (this.paginationWrapper) {
        this.paginationWrapper.classList.remove('hide');
      }
    }
  }
}

customElements.define('facet-remove', FacetRemove);
